import { render, staticRenderFns } from "./AdminPointTransactionList.vue?vue&type=template&id=82bbd64a"
import script from "./AdminPointTransactionList.vue?vue&type=script&lang=js"
export * from "./AdminPointTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports